<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Surveillance</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's surveillance system. Our surveillance system is in place to ensure the safety and security of our students, staff, and visitors. At our school, we are committed to ensuring the safety and security of our students and staff, and our surveillance system is an essential part of our efforts to maintain a safe and secure learning environment.
                    </p>  
                    <p class="inner-lead">We take the privacy of our students and staff seriously, and our surveillance system is designed to only capture footage in public areas of our campus. Our system is also compliant with all applicable privacy laws and regulations, and we ensure that any footage captured is used only for security purposes.
                    </p>
                    <p class="inner-lead">Our commitment to the safety and security of our students and staff is unwavering, and our surveillance system is an essential part of that commitment. We believe that a safe and secure learning environment is essential for the academic and personal growth of our students, and our surveillance system plays a critical role in achieving that goal.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>